import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || '';

/** The one request that touches Shopify: catalog prices plus on-hand for a chosen master. */
export function useStyleResolve({ onSuccess, onError }) {
    return useMutation({
        mutationFn: async ({ productId, locationGid }) => {
            const response = await axios.post(`${API_URL}/api/app/products/search-by-style`, { productId, locationGid }, { withCredentials: true });
            if (!response.data.success) throw new Error(response.data.message || 'Failed to load style');
            return response.data.data;
        },
        onSuccess,
        onError,
    });
}
